// src/Components/Accueil/DemoForm.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assets/logo.jpg';

const DemoForm = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans">
      {/* Header identique à Accueil */}
      <header className="flex justify-between items-center px-8 py-6 shadow-md sticky top-0 z-50 bg-white">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="GenIaC Logo" className="h-20 w-auto object-contain" />
        </div>

        <nav className="flex items-center space-x-6 text-gray-700 font-medium">
          <Link to="/">Accueil</Link>
          <Link to="/solutions">Solutions</Link>
          <a href="#tarifs">Tarifs</a>
          <Link to="/home">Demo</Link>
          <a href="#blog">Blog</a>
          <Link to="/login">CONNEXION</Link>
          <Link to="/register">
            <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
              INSCRIPTION
            </button>
          </Link>
        </nav>
      </header>

      {/* Formulaire de demande de démo */}
      <section className="max-w-2xl mx-auto py-20 px-6">
        <h2 className="text-3xl font-bold mb-6 text-center">Demander une démonstration</h2>
        <form className="space-y-6">
          <div>
            <label className="block text-sm font-medium mb-1">Nom complet</label>
            <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2" required />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Adresse email</label>
            <input type="email" className="w-full border border-gray-300 rounded-md px-4 py-2" required />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Nom de l'entreprise</label>
            <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Message</label>
            <textarea rows={4} className="w-full border border-gray-300 rounded-md px-4 py-2" placeholder="Décrivez vos besoins..." />
          </div>
          <button type="submit" className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition">
            Envoyer la demande
          </button>
        </form>
      </section>
    </div>
  );
};

export default DemoForm;
